<template>
  <div>
    <vue-element-loading :active="appLoading" :is-full-screen="true" background-color="#FFFFFF" color="#005f32"
      spinner="bar-fade-scale" />
    <v-snackbar v-model="showsnackbar" color="#005f32" right>
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showsnackbar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap>
      <v-flex xs12 align-self-center>
        <!-- <v-card> -->
        <v-card-title class="elevation-0">
          <v-layout wrap justify-end>
            <v-flex shrink px-2 pt-2 align-self-center text-left>
              <v-btn-toggle v-model="viewMode" mandatory dense color="#005f32">
                <v-btn value="list" icon color="#005f32">
                  <v-icon>mdi-view-list</v-icon>
                </v-btn>
                <v-btn value="grid" icon color="#005f32">
                  <v-icon>mdi-view-grid</v-icon>
                </v-btn>
              </v-btn-toggle>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xl3 lg3 md3 py-2 sm3 xs12 px-2 align-self-center>
              <v-text-field v-model="keysearch" outlined class="rounded-xl" dense hide-details clearable
                label="Search Employee">
              </v-text-field>
            </v-flex>
            <v-flex xs12 sm3 md3 lg2 xl2 pa-1 pt-2 text-left style="font-family: poppinsregular">
              <v-btn dark block class="rounded-xl" color="#005f32" @click="openExportDialog()">
                Excel Download
              </v-btn>
            </v-flex>

            <v-flex xl3 lg3 md3 pb-2 sm3 xs12 px-0 pl-0 pl-sm-5 align-self-center>
              <v-dialog :retain-focus="false" v-model="dialog" persistent fullscreen hide-overlay
                transition="dialog-bottom-transition" :key="dialog">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn style="font-family: kumbhMedium" block color="#005f32" dark class="rounded-xl" v-bind="attrs"
                    v-on="on" @click="getUsers1(), getUsers2(), getUsers3(), getDivisions()">
                    Add Employee
                  </v-btn>
                </template>
                <v-card>
                  <v-form v-model="addcat" ref="addcat">
                    <v-layout wrap>
                      <v-flex xs12 pa-4 text-left align-self-center style="background: #005f32 !important">
                        <!-- <span
                        class="kumbhBold"
                        style="color: #ffffff; font-size: 20px"
                        >Add Employee</span
                      > -->

                        <v-layout wrap>
                          <v-flex xs6 align-self-center text-left>
                            <span class="kumbhBold" style="color: #ffffff; font-size: 20px">Add Employee</span>
                          </v-flex>
                          <v-flex xs6 align-self-center text-right>
                            <v-btn icon color="white" text @click="dialog = false">
                              <v-icon color="#ffffff">mdi-close</v-icon>
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs12 pa-4></v-flex>
                      <v-flex xs12 align-self-center px-3>
                        <v-layout wrap>
                          <v-flex xs12 sm6 align-self-center text-left pa-2 px-4>
                            <v-text-field v-model="user.employeeId" label="Employee ID" :rules="[rules.required]"
                              required outlined dense></v-text-field>
                          </v-flex>
                          <v-flex xs12 sm6 align-self-center text-left pa-2 px-4>
                            <v-text-field v-model="user.name" label="Employee Name" :rules="[rules.required]" required
                              outlined dense></v-text-field>
                          </v-flex>

                          <v-flex xs12 sm6 align-self-center text-left pa-2 px-4>
                            <v-text-field v-model="user.email" label="Email" :rules="emailRules" required outlined
                              dense></v-text-field>
                          </v-flex>
                          <v-flex xs12 sm6 align-self-center text-left pa-2 px-4>
                            <v-menu ref="menu" v-model="menu" :close-on-content-click="false"
                              transition="scale-transition" offset-y max-width="290px" min-width="auto">
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field v-model="displayDob" label="DOB" outlined dense v-bind="attrs"
                                  v-on="on"></v-text-field>
                              </template>
                              <v-date-picker v-model="user.dob" no-title min="1930-01-01" :max="maxDate" @input="
                                menu = false;
                              getAge(user.dob);
                              "></v-date-picker>
                            </v-menu>
                          </v-flex>
                          <v-flex xs12 sm6 align-self-center text-left pa-2 px-4>
                            <v-text-field v-model="user.age" label="Age" readonly type="number" outlined
                              @wheel="$event.target.blur()" dense></v-text-field>
                          </v-flex>
                          <v-flex xs12 sm6 align-self-center text-left pa-2 px-4>
                            <v-text-field v-model="user.phonenumber" label="Phone Number" :rules="phnoRules" required
                              outlined @wheel="$event.target.blur()" type="number" dense></v-text-field>
                          </v-flex>

                          <v-flex xs12 sm6 align-self-center text-left pa-2 px-4>
                            <v-textarea v-model="user.address" label="Address" :rules="[rules.required]" required
                              outlined dense></v-textarea>
                          </v-flex>

                          <v-flex xs12 sm6 align-self-center text-left pa-2 px-4>
                            <v-radio-group dense hide-details v-model="user.gender" column label="Gender">
                              <v-radio label="Male" value="Male"></v-radio>
                              <v-radio label="Female" value="Female"></v-radio>
                              <v-radio label="Other" value="Other"></v-radio>
                            </v-radio-group>
                          </v-flex>

                          <v-flex xs12 sm6 align-self-center text-left pa-2 px-4>
                            <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false"
                              transition="scale-transition" offset-y max-width="290px" min-width="auto">
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field v-model="displayDateOfJoining" label="Date of joining" outlined dense
                                  v-bind="attrs" v-on="on"></v-text-field>
                              </template>
                              <v-date-picker v-model="user.dateofjoining" no-title
                                @input="menu2 = false; calculateProbationDate(user)"></v-date-picker>
                            </v-menu>
                          </v-flex>
                          <v-flex xs12 sm6 align-self-center text-left pa-2 px-4>
                            <v-select v-model="user.probationDuration" :items="probationDurations"
                              label="Probation Duration" outlined dense
                              @change="calculateProbationDate(user)"></v-select>
                          </v-flex>
                          <v-flex xs12 sm6 align-self-center text-left pa-2 px-4>
                            <v-text-field v-model="user.dateofProbationCompletion" label="Date of probation completion"
                              outlined dense disabled></v-text-field>
                          </v-flex>
                          <v-flex xs12 sm6 align-self-center text-left pa-2 px-4>
                            <v-select 
  v-model="user.probationExtensionMonths" 
  :items="extensionOptions"
  item-text="text"
  item-value="value"
  label="Probation Extension" 
  outlined dense clearable
  @change="calculateProbationDate(user)"
></v-select>
                          </v-flex>

                          <!-- <v-flex
                            xs12
                            sm6
                            align-self-center
                            text-left
                            pa-2
                            px-4
                          >
                            <v-text-field
                              v-model="user.salary"
                              label="Salary"
                              outlined
                              dense
                            ></v-text-field>
                          </v-flex> -->

                          <v-flex xs12 sm6 align-self-center text-left pa-2 px-4>
                            <v-text-field v-model="user.grade" label="Grade" outlined dense></v-text-field>
                          </v-flex>
                          <v-flex xs12 sm6 align-self-center text-left pa-2 px-4>
                            <v-select v-model="user.location" :items="locationList" item-color="#005f32" color="#005f32"
                              outlined dense label="Choose Location">
                            </v-select>
                          </v-flex>

                          <v-flex xs12 sm6 align-self-center text-left pa-2 px-4>
                            <v-text-field v-model="user.officialEmail" label="Official Email address"
                              :rules="[rules.required]" required outlined dense></v-text-field>
                          </v-flex>
                          <v-flex xs12 sm6 align-self-center text-left pa-2 px-4>
                            <v-text-field v-model="user.monthlyCTC" label="Monthly CTC" :rules="[rules.required]"
                              required outlined dense></v-text-field>
                          </v-flex>
                          <v-flex xs12 sm6 align-self-center text-left pa-2 px-4>
                            <v-text-field v-model="user.yearlyPackage" label="Yearly Package" readonly outlined dense
                              :hint="user.monthlyCTC ? `Calculated as ${user.monthlyCTC} × 12` : 'Enter Monthly CTC to calculate'"></v-text-field>
                          </v-flex>
                          <v-flex xs12 sm6 align-self-center text-left pa-2 px-4>
                            <v-select v-model="user.employeeStatus" :items="statusList" item-text="name"
                              item-value="name" item-color="#005f32" color="#005f32" outlined dense
                              label="Choose Employee status">
                            </v-select>
                          </v-flex>
                          <v-flex xs12 sm6 align-self-center text-left pa-2 px-4>
                            <v-textarea v-model="user.officeAddress" label="Office Address" :rules="[rules.required]"
                              required outlined dense></v-textarea>
                          </v-flex>
                          <v-flex xs12 sm6 align-self-center text-left pa-2 px-4>
                            <v-textarea v-model="user.education" label="Education - Degree/ Diploma"
                              :rules="[rules.required]" required outlined dense></v-textarea>
                          </v-flex>


                          <!-- <v-flex
                            xs12
                            sm6
                            align-self-center
                            text-left
                            pa-2
                            px-4
                          >
                            <v-select
                              v-model="department"
                              :items="departmentList"
                              item-text="deptName"
                              item-value="_id"
                              outlined
                              multiple
                              dense
                              :rules="[rules.required]"
                              required
                              label="Choose Department"
                            >
                            </v-select>
                          </v-flex> -->
                          <v-flex xs12 sm6 align-self-center text-left pa-2 px-4>
                            <!-- <v-select
                              v-model="project"
                              :items="projectList"
                              item-text="projectName"
                              multiple
                              item-value="_id"
                              outlined
                              dense
                              label="Choose Project"
                            >
                            </v-select> -->

                            <v-autocomplete v-model="project" :items="projectList" item-text="projectName" multiple
                              item-value="_id" outlined dense label="Choose Project"></v-autocomplete>
                          </v-flex>

                          <v-flex xs12 sm6 align-self-center text-left pa-2 px-4>
                            <v-autocomplete v-model="division" :items="divisionList" item-text="divisiontName" multiple
                              item-value="_id" outlined dense label="Choose Division">
                            </v-autocomplete>
                          </v-flex>

                          <v-flex xs12 sm6 align-self-center text-left pa-2 px-4>
                            <v-autocomplete v-model="user.positionid" :items="positionList" item-text="name"
                              item-value="_id" outlined dense label="Choose Position(s)">
                            </v-autocomplete>
                          </v-flex>

                          <v-flex xs12 sm6 align-self-center text-left pa-2 px-4>
                            <v-text-field v-model="user.role" label="Role" outlined dense></v-text-field>
                          </v-flex>



                          <v-flex xs12 sm6 align-self-center text-left pa-2 px-4>
                            <v-autocomplete v-model="user.administrativeReportingManagersIds" :items="empList1"
                              item-text="name" :search-input.sync="search1" item-value="_id" outlined multiple
                              label="Choose Administrative Reporting Manager" dense></v-autocomplete>
                          </v-flex>

                          <v-flex xs12 sm6 align-self-center text-left pa-2 px-4>
                            <!-- <v-select
                          v-model="user.technicalReportingManager"
                          :items="empList2"
                          item-text="name"
                          item-value="_id"
                          outlined
                          dense
                          label="Choose Technical Reporting Manager"
                        >
                        </v-select> -->

                            <v-autocomplete v-model="user.technicalReportingManagersIds" :items="empList2"
                              item-text="name" :search-input.sync="search22" item-value="_id" outlined multiple
                              label="Choose Technical Reporting Manager" dense></v-autocomplete>
                          </v-flex>

                          <v-flex xs12 sm6 align-self-center text-left pa-2 px-4>
                            <v-autocomplete v-model="user.principalInvigilator" :items="empList3" item-text="name"
                              :search-input.sync="search3" item-value="_id" outlined
                              label="Choose Principal Invigilator/Investigator" dense></v-autocomplete>
                          </v-flex>

                          <!-- <v-flex xs12 sm6 align-self-center text-left pa-2 px-4>
                            <v-text-field v-model="user.allottedLeaves" label="Allotted Leaves" type="number" outlined
                              dense @wheel="$event.target.blur()"></v-text-field>
                          </v-flex> -->

                          <v-flex xs12 sm6 align-self-center text-left pa-2 px-4>
                            <v-text-field v-model="user.experienceBeforeWTI" label="Experience before WTI" type="number"
                              :rules="[rules.required]" required outlined dense></v-text-field>
                          </v-flex>

                          <v-flex xs12 sm6 align-self-center text-left pa-2 px-4>
                            <v-select v-model="user.fieldOfEducationCategory"
                              :items="['Highest Education', 'Additional Qualification']"
                              label="Field of Education Category" outlined dense :rules="[rules.required]" required
                              @change="user.fieldOfEducation = null"></v-select>
                          </v-flex>
                          <v-flex xs12 sm6 align-self-center text-left pa-2 px-4
                            v-if="user.fieldOfEducationCategory === 'Highest Education'">
                            <v-select v-model="user.fieldOfEducation" :items="highestEducationOptions"
                              label="Highest Education" item-text="text" item-value="value" outlined dense
                              :rules="[rules.required]" required></v-select>
                          </v-flex>
                          <v-flex xs12 sm6 align-self-center text-left pa-2 px-4
                            v-if="user.fieldOfEducationCategory === 'Additional Qualification'">
                            <v-select v-model="user.fieldOfEducation" :items="additionalQualificationOptions"
                              label="Additional Qualification" item-text="text" item-value="value" outlined dense
                              :rules="[rules.required]" required></v-select>
                          </v-flex>

                          <v-flex xs12 sm6 align-self-center text-left pa-2 px-4>
                            <v-select v-model="user.staffType" :items="['HQ', 'Field']" label="Staff Type" outlined
                              dense :rules="[rules.required]" required></v-select>
                          </v-flex>

                          <v-flex xs12 pa-4 pb-12 align-self-center>
                            <v-divider></v-divider>
                          </v-flex>

                          <!-- <v-flex
                            xs12
                            sm6
                            align-self-center
                            text-left
                            pa-2
                            px-4
                          > -->
                          <!-- <v-select
                            v-model="user.administrativeReportingManager"
                            :items="empList1"
                            item-text="name"
                            item-value="_id"
                            outlined
                            dense
                            label="Choose Administrative Reporting Manager"
                          >
                          </v-select> -->
                          <!-- <v-autocomplete
                              v-model="user.administrativeReportingManager"
                              :items="empList1"
                              item-text="name"
                              :search-input.sync="search11"
                              item-value="_id"
                              outlined
                              hide-details
                              label="Choose Administrative Reporting Manager"
                              dense
                            ></v-autocomplete>
                          </v-flex> -->



                          <!-- <v-flex
                            xs12
                            sm6
                            align-self-center
                            text-left
                            pa-2
                            px-4
                          > -->
                          <!-- <v-select
                            v-model="user.principalInvigilator"
                            :items="empList3"
                            item-text="name"
                            item-value="_id"
                            outlined
                            dense
                            label="Choose Principal Invigilator/Investigator"
                          >
                          </v-select> -->
                          <!-- 
                            <v-autocomplete
                              v-model="user.principalInvigilator"
                              :items="empList3"
                              item-text="name"
                              :search-input.sync="search33"
                              item-value="_id"
                              outlined
                              hide-details
                              label="Choose Principal Invigilator/Investigator"
                              dense
                            ></v-autocomplete>
                          </v-flex> -->
                          <!-- <v-flex xs12 align-self-center pa-2>
                            <v-divider></v-divider>
                          </v-flex> -->

                          <v-flex xs12 sm6 pa-2 px-4 v-if="flagg">
                            <ImageComp @stepper="winStepper" :height="'320'" :width="'320'"
                              :heading="'Upload Profile Picture'" :componentType="'coverImage'" />
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" text @click="dialogclose()">
                        Close
                      </v-btn>
                      <v-btn color="blue darken-1" text :disabled="!addcat" @click="validateEmp()">
                        Save
                      </v-btn>
                    </v-card-actions>
                  </v-form>
                </v-card>
              </v-dialog>
            </v-flex>

            <v-flex xs12>
              <v-spacer></v-spacer>
            </v-flex>
            <v-spacer></v-spacer>

            <v-flex xl3 lg3 align-self-center md3 py-2 sm3 xs12 px-2 v-if="moreFilter">
              <v-select v-model="ffdepartment" :items="ffdepartmentList" item-text="deptName" item-value="_id" outlined
                class="rounded-xl" dense clearable label="Division">
              </v-select>
            </v-flex>
            <v-flex xl3 lg3 align-self-center md3 py-2 sm3 xs12 px-2 pr-3 v-if="moreFilter">
              <v-select v-model="ffproject" :items="ffprojectList" item-text="projectName" item-value="_id" outlined
                class="rounded-xl" dense clearable label="Project">
              </v-select>
            </v-flex>
            <v-flex xl3 align-self-center lg3 md3 py-2 sm3 xs12 px-2 pr-3 v-if="moreFilter">
              <v-select v-model="ffposition" :items="ffpositionList" item-text="name" item-value="_id" outlined
                class="rounded-xl" dense clearable label="Positions">
              </v-select>
            </v-flex>
            <v-flex xl3 align-self-center lg3 md3 py-2 sm3 xs12 px-2 pr-3 v-if="moreFilter">
              <v-autocomplete v-model="ffreportingManager" :items="empList1" item-text="name"
                :search-input.sync="searchManager" item-value="_id" outlined class="rounded-xl" dense clearable
                label="Technical Reporting Manager">
              </v-autocomplete>
            </v-flex>
            <v-flex xl3 align-self-center lg3 md3 py-2 sm3 xs12 px-2 pr-3 v-if="moreFilter">
              <v-autocomplete v-model="ffadministrativereportingManager" :items="empList2" item-text="name"
                :search-input.sync="searchAdminstrativeManager" item-value="_id" outlined class="rounded-xl" dense
                clearable label="Administrative Reporting Manager">
              </v-autocomplete>
            </v-flex>
            <v-flex xl3 align-self-center lg3 md3 py-2 sm3 xs12 px-2 pr-3 v-if="moreFilter">
              <v-select v-model="fflocation" :items="locationList" outlined class="rounded-xl" dense clearable
                label="Location">
              </v-select>
            </v-flex>
            <v-flex xl3 align-self-center lg3 md3 py-2 sm3 xs12 px-2 pr-3 v-if="moreFilter">
              <v-text-field v-model="ffsalaryMin" label="Min Monthly Salary" type="number" outlined class="rounded-xl"
                dense clearable @wheel="$event.target.blur()"></v-text-field>
            </v-flex>
            <v-flex xl3 align-self-center lg3 md3 py-2 sm3 xs12 px-2 pr-3 v-if="moreFilter">
              <v-text-field v-model="ffsalaryMax" label="Max Monthly Salary" type="number" outlined class="rounded-xl"
                dense clearable @wheel="$event.target.blur()"></v-text-field>
            </v-flex>
            <v-flex xl3 align-self-center lg3 md3 py-2 sm3 xs12 px-2 pr-3 v-if="moreFilter">
              <v-select v-model="ffsort" :items="sortList" outlined class="rounded-xl" dense clearable label="Sort By">
              </v-select>
            </v-flex>
            <v-flex xl3 align-self-center lg3 md3 py-2 sm3 xs12 px-2 pr-3 v-if="moreFilter">

            </v-flex>
            <v-flex xl3 align-self-center lg3 md3 py-2 sm3 xs12 px-2 pr-3 v-if="moreFilter">

            </v-flex>
            <v-flex xl3 align-self-center lg3 md3 py-2 sm3 xs12 px-2 pr-3 v-if="moreFilter">

            </v-flex>



            <v-flex xs2 align-self-start text-right pb-2 sm3 px-5>
              <span v-if="!moreFilter" @click="moreFilter = true" style="font-size: 14px; cursor: pointer"
                class="kumbhMedium">
                <v-icon>mdi-filter-variant-plus</v-icon> More filters..</span>
              <span v-if="moreFilter" @click="
                (moreFilter = false), (project = null), (department = null)
                " style="font-size: 14px; cursor: pointer"
                class="kumbhMedium"><v-icon>mdi-filter-variant-minus</v-icon>Show less</span>
            </v-flex>
          </v-layout>
        </v-card-title>

        <v-layout wrap justify-start v-if="viewMode === 'list'">
          <v-flex xs12 align-self-center pa-4>
            <v-simple-table fixed-header>
              <template v-slot:default>
                <thead>
                  <tr class="kumbhEBold">
                    <th class="text-left">Name</th>
                    <th class="text-left">E-mail</th>
                    <th class="text-left">Employee Id</th>
                    <th class="text-left">View Profile</th>
                    <th class="text-left">Edit</th>
                    <th class="text-left">Delete</th>
                    <th class="text-left">Attachments</th>
                  </tr>
                </thead>
                <tbody class="kumbhRegular">
                  <tr v-for="(item, i) in employeeList" :key="i">
                    <!-- <td class="text-left">
                      <span v-if="item.photo" class="rounded-lg">
                        <v-img
                          contain
                          height="42px"
                          width="42px"
                          class="rounded-lg"
                          :src="mediaURL + item.photo"
                        ></v-img>
                      </span>
                      <span v-else class="rounded-lg">
                        <v-img
                          contain
                          height="42px"
                          width="42px"
                          class="rounded-lg"
                          :src="require('./../../assets/images/nopic.jpg')"
                        ></v-img>
                      </span>
                    </td> -->

                    <td class="text-left">
                      <span v-if="item.name">
                        {{ item.name }}
                      </span>
                      <span v-else> - </span>
                      <!-- <span v-else-if="item.email">
                        {{ item.email }}
                      </span> -->
                    </td>
                    <td class="text-left">
                      <span>{{ item.email }}</span>
                    </td>

                    <td class="text-left">
                      <span>{{ item.employeeId }}</span>
                    </td>

                    <td class="text-left">
                      <v-layout wrap>
                        <v-flex xs6 sm4 md2>
                          <v-btn color="#005f32" style="font-family: kumbhMedium" small title="View details" block icon
                            :to="'/viewEmployee?id=' + item._id">
                            <v-icon color="#005f32">
                              mdi-eye-settings-outline
                            </v-icon>
                          </v-btn>
                        </v-flex>


                        <!-- <v-flex xs6 sm4 md2 pa-2>
                          <v-dialog
                            persistent
                            v-model="item.delete"
                            max-width="600px"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                small
                                style="font-family: kumbhMedium"
                                class="mr-2"
                                icon
                                title="Delete"
                                block
                                v-on="on"
                                v-bind="attrs"
                                color="#005f32"
                              >
                                <v-icon> mdi-delete-alert-outline </v-icon>
                              </v-btn>
                            </template>
      <v-card>
        <v-layout wrap>
          <v-flex xs12 align-self-center pa-4 style="background: #005f32" text-left>
            <span class="kumbhBold" style="color: #ffffff">Delete Confirmation</span>
          </v-flex>
        </v-layout>
        <v-card-title>Are you sure you want to delete this
          Employee?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" tile dark @click="item.delete = false">Cancel</v-btn>
          <v-btn color="#005f32" outlined tile @click="deleteItem(item)">Delete</v-btn>
        </v-card-actions>
      </v-card>
      </v-dialog>
  </v-flex> -->
                      </v-layout>
                    </td>
                    <td class="text-left">
                      <v-layout wrap>
                        <v-flex xs6 sm4 md2>
                          <v-btn color="#005f32" style="font-family: kumbhMedium" small title="Edit" block icon @click="
                            editcat(item), (test = editingitem.positionid._id)
                            ">
                            <v-icon> mdi-circle-edit-outline </v-icon>
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </td>


                    <!-- <td class="text-left">
                      <v-layout wrap justify-start>
                        <v-flex xs6 sm4 md2>
                          <v-dialog persistent v-model="item.delete" max-width="600px">
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn small style="font-family: kumbhMedium" class="mr-2" icon title="Delete" block
                                v-on="on" v-bind="attrs" color="#005f32">
                                <v-icon>mdi-delete-alert-outline</v-icon>
                              </v-btn>
                            </template>
                            <v-card>
                              <v-layout wrap>
                                <v-flex xs12 align-self-center pa-4 style="background: #005f32" text-left>
                                  <span class="kumbhBold" style="color: #ffffff">Delete Confirmation</span>
                                </v-flex>
                              </v-layout>
                              <v-card-title>Are you sure you want to delete this Employee?</v-card-title>
                              <v-card-text>
                                <v-textarea v-model="item.deleteReason" label="Remarks"
                                  :rules="[v => !!v || 'Remarks is mandatory']" required outlined dense></v-textarea>
                              </v-card-text>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="error" tile dark @click="item.delete = false">
                                  Cancel
                                </v-btn>
                                <v-btn color="#005f32" outlined :disabled="!item.deleteReason" tile @click="openSecondDialog(item)">
                                  Yes
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </v-flex>
                      </v-layout>
                    </td> -->
                    <td class="text-left">
                      <v-layout wrap justify-start>
                        <v-flex xs6 sm4 md2>
                          <v-btn small style="font-family: kumbhMedium" class="mr-2" icon title="Delete" block
                            color="#005f32" @click="openSecondDialog(item)">
                            <v-icon>mdi-delete-alert-outline</v-icon>
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </td>
                    <td class="text-left">
                      <v-btn icon small color="#005f32" @click="openAttachmentDialog(item)">
                        <v-icon>mdi-paperclip</v-icon>
                      </v-btn>
                    </td>

                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-flex>
        </v-layout>

        <v-layout wrap justify-start v-else-if="viewMode === 'grid'" class="pa-4">
          <v-flex
            xs12 sm6 md4 lg3 xl2
            v-for="(item, i) in employeeList"
            :key="i"
            pa-3
            style="display: flex;"
          >
            <v-card
              color="#0d6537"
              dark
              class="rounded-lg text-center pb-3 d-flex flex-column"
              elevation="4"
              style="border: 2px solid #005f32; border-radius: 12px; position: relative; width: 100%; height: 100%;"
            >
              <div class="pt-2 font-weight-bold" style="font-size: 14px; letter-spacing: 0.5px; font-family: kumbhBold;">EMPLOYEE CARD</div>
              <v-img
                :src="require('./../../../public/wtilogo.png')"
                contain
                height="50"
                class="mt-1 mb-2 mx-auto"
                style="filter: brightness(0) invert(1); flex-shrink: 0;"
              ></v-img>
              
              <div class="my-1" style="flex-shrink: 0;">
                <v-img
                  v-if="item.photo"
                  :src="mediaURL + item.photo"
                  height="110"
                  width="95"
                  class="mx-auto"
                  style="border: 2px solid white; background-color: #fff;"
                ></v-img>
                <v-img
                  v-else
                  :src="require('./../../assets/images/nopic.jpg')"
                  height="110"
                  width="95"
                  class="mx-auto"
                  style="border: 2px solid white; background-color: #fff;"
                ></v-img>
              </div>
              
              <div style="font-size: 13.5px; line-height: 1.2;" class="px-3 mt-2">
                <div style="font-family: kumbhMedium; margin-bottom: 2px;">Emp ID: {{ item.employeeId || '-' }}</div>
                <div style="font-size: 15px; font-family: kumbhBold; min-height: 36px;">{{ item.name || '-' }}</div>
                <div style="font-family: kumbhRegular; min-height: 32px;">{{ item.positionid ? item.positionid.name : (item.role || '-') }}</div>
                <div style="font-family: kumbhRegular; min-height: 32px;" class="px-1">
                  <template v-if="item.project && item.project.length > 0 && getProjectNames(item.project)">
                    {{ getProjectNames(item.project) }}
                  </template>
                  <template v-else-if="item.projects && item.projects.length > 0 && getProjectNames(item.projects)">
                    {{ getProjectNames(item.projects) }}
                  </template>
                  <template v-else>
                    &nbsp;
                  </template>
                </div>
                <div style="font-family: kumbhRegular; min-height: 32px;" class="px-1">
                  <template v-if="item.division && item.division.divisiontName">
                    {{ item.division.divisiontName }}
                  </template>
                  <template v-else-if="item.department && item.department.length > 0 && item.department[0].deptName">
                    {{ item.department[0].deptName }}
                  </template>
                  <template v-else>
                    &nbsp;
                  </template>
                </div>
              </div>
            </v-card>
          </v-flex>
        </v-layout>
        <!-- <v-layout wrap justify-start>
          <v-flex
            xs12
            md6
            sm6
            lg4
            xl3
            align-self-center
            v-for="(item, i) in employeeList"
            :key="i"
            fill-height
            pa-4
          >
            <v-card tile flat outlined>
              <v-layout wrap justify-center py-4>
                <v-flex xs12 align-self-start text-left pa-3>
                  
                  <span style="font-family: kumbhMedium">{{ item.email }}</span>
                </v-flex>

                <v-flex xs12 sm6 lg6 pa-2>
                  <v-btn
                    color="success"
                    style="font-family: kumbhMedium"
                    small
                    block
                    outlined
                    @click="editcat(item)"
                    >Edit</v-btn
                  >
                </v-flex>
                <v-flex xs12 sm6 lg6 pa-2>
                  <v-dialog persistent v-model="item.delete" max-width="600px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        small
                        style="font-family: kumbhMedium"
                        class="mr-2"
                        outlined
                        block
                        v-on="on"
                        v-bind="attrs"
                        color="red"
                      >
                        Delete
                      </v-btn>
                    </template>
                    <v-card>
                      <v-card-title
                        >Are you sure you want to delete this
                        Employee?</v-card-title
                      >
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          color="blue darken-1"
                          text
                          @click="item.delete = false"
                          >Cancel</v-btn
                        >
                        <v-btn
                          color="blue darken-1"
                          text
                          @click="deleteItem(item)"
                          >OK</v-btn
                        >
                        <v-spacer></v-spacer>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>


         
        </v-layout> -->
        <!-- </v-card> -->
      </v-flex>
    </v-layout>

    <v-dialog persistent fullscreen hide-overlay transition="dialog-bottom-transition" v-model="editdialog">
      <v-card tile>
        <v-layout wrap>
          <v-flex xs12 pa-4 text-left align-self-center style="background: #005f32 !important">
            <v-layout wrap>
              <v-flex xs6 align-self-center text-left>
                <span class="kumbhBold" style="color: #ffffff; font-size: 20px">Edit Employee</span>
              </v-flex>
              <v-flex xs6 align-self-center text-right>
                <v-btn icon color="white" text @click="getdData">
                  <v-icon color="#ffffff">mdi-close</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 pa-4></v-flex>
          <v-flex xs12 align-self-center px-3>
            <v-layout wrap>
              <v-flex xs12 sm6 align-self-center text-left pa-2 px-4>
                <v-text-field v-model="editingitem.employeeId" label="Employee ID" :rules="[rules.required]" required
                  outlined dense></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 align-self-center text-left pa-2 px-4>
                <v-text-field v-model="editingitem.name" label="Employee Name" :rules="[rules.required]" required
                  outlined dense></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 align-self-center text-left pa-2 px-4>
                <v-text-field v-model="editingitem.email" label="Email" :rules="emailRules" required outlined
                  dense></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 align-self-center text-left pa-2 px-4>
                <v-menu ref="menu" v-model="menu1" :close-on-content-click="false" transition="scale-transition"
                  offset-y max-width="290px" min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="displayEditDob" label="DOB" outlined dense v-bind="attrs"
                      v-on="on"></v-text-field>
                  </template>
                  <v-date-picker v-model="editingitem.dob" no-title min="1930-01-01" :max="maxDate"
                    @input="(menu1 = false), getAge(editingitem.dob)"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12 sm6 align-self-center text-left pa-2 px-4>
                <v-text-field v-model="editingitem.age" label="Age" readonly :rules="[rules.required]" required
                  type="number" outlined @wheel="$event.target.blur()" dense></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 align-self-center text-left pa-2 px-4>
                <v-text-field v-model="editingitem.phonenumber" :rules="phnoRules" required outlined
                  @wheel="$event.target.blur()" type="number" dense></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 align-self-center text-left pa-2 px-4>
                <v-textarea v-model="editingitem.address" label="Address" required outlined dense></v-textarea>
              </v-flex>

              <v-flex xs12 sm6 align-self-center text-left pa-2 px-4>
                <v-radio-group dense hide-details v-model="editingitem.gender" column label="Gender">
                  <v-radio label="Male" value="Male"></v-radio>
                  <v-radio label="Female" value="Female"></v-radio>
                  <v-radio label="Other" value="Other"></v-radio>
                </v-radio-group>
              </v-flex>

              <v-flex xs12 sm6 align-self-center text-left pa-2 px-4>
                <v-menu ref="menu2" v-model="menu22" :close-on-content-click="false" transition="scale-transition"
                  offset-y max-width="290px" min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="displayEditDateOfJoining" label="Date of joining" outlined dense
                      v-bind="attrs" v-on="on"></v-text-field>
                  </template>
                  <v-date-picker v-model="editingitem.dateofjoining" no-title @input="menu22 = false; calculateProbationDate(editingitem)"></v-date-picker>
                </v-menu>
              </v-flex>

              <!-- <v-flex xs12 sm6 align-self-center text-left pa-2 px-4>
                <v-text-field
                  v-model="editingitem.salary"
                  label="Salary"
                  :rules="[rules.required]"
                  required
                  outlined
                  dense
                ></v-text-field>
              </v-flex> -->

              <v-flex xs12 sm6 align-self-center text-left pa-2 px-4>
                <v-text-field v-model="editingitem.grade" label="Grade" :rules="[rules.required]" required outlined
                  dense></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 align-self-center text-left pa-2 px-4>
                <v-select v-model="editingitem.probationDuration" :items="probationDurations" label="Probation Duration"
                  outlined dense @change="calculateProbationDate(editingitem)"></v-select>
              </v-flex>
              <v-flex xs12 sm6 align-self-center text-left pa-2 px-4>
                <v-text-field v-model="editingitem.dateofProbationCompletion" label="Date of probation completion"
                  outlined dense disabled></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 align-self-center text-left pa-2 px-4>
                <v-select 
  v-model="editingitem.probationExtensionMonths" 
  :items="extensionOptions"
  item-text="text"
  item-value="value"
  label="Probation Extension" 
  outlined dense clearable
  @change="calculateProbationDate(editingitem)"
></v-select>
              </v-flex>
              <v-flex xs12 sm6 align-self-center text-left pa-2 px-4>
                <v-select v-model="editingitem.location" :items="locationList" item-color="#005f32" color="#005f32"
                  outlined dense label="Choose Location">
                </v-select>
              </v-flex>

              <v-flex xs12 sm6 align-self-center text-left pa-2 px-4>
                <v-text-field v-model="editingitem.officialEmail" label="Official Email address"
                  :rules="[rules.required]" required outlined dense></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 align-self-center text-left pa-2 px-4>
                <v-text-field v-model="editingitem.monthlyCTC" label="Monthly CTC" :rules="[rules.required]" required
                  outlined dense></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 align-self-center text-left pa-2 px-4>
                <v-text-field v-model="editingitem.yearlyPackage" label="Yearly Package" readonly outlined dense
                  :hint="editingitem.monthlyCTC ? `Calculated as ${editingitem.monthlyCTC} × 12` : 'Enter Monthly CTC to calculate'"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 align-self-center text-left pa-2 px-4>
                <v-select v-model="editingitem.employeeStatus" :items="statusList" item-text="name" item-value="name"
                  item-color="#005f32" color="#005f32" outlined dense label="Choose Employee status">
                </v-select>
              </v-flex>
              <v-flex xs12 sm6 align-self-center text-left pa-2 px-4>
                <v-textarea v-model="editingitem.officeAddress" label="Office Address" required outlined
                  dense></v-textarea>
              </v-flex>
              <v-flex xs12 sm6 align-self-center text-left pa-2 px-4>
                <v-textarea v-model="editingitem.education" label="Education - Degree/ Diploma"
                  :rules="[rules.required]" required outlined dense></v-textarea>
              </v-flex>


              <!-- <v-flex xs12 sm6 align-self-center text-left pa-2 px-4>
                <v-select
                  v-model="department"
                  :items="departmentList"
                  item-text="deptName"
                  item-value="_id"
                  outlined
                  multiple
                  dense
                  :rules="[rules.required]"
                  required
                  label="Choose Department"
                >
                </v-select>
              </v-flex> -->
              <v-flex xs12 sm6 align-self-center text-left pa-2 px-4>
                <v-autocomplete v-model="editingitem.projects" :items="projectList" item-text="projectName" multiple
                  item-value="_id" outlined dense label="Choose Project">
                </v-autocomplete>
              </v-flex>

              <v-flex xs12 sm6 align-self-center text-left pa-2 px-4>
                <v-autocomplete v-model="editingitem.division" :items="divisionList" item-text="divisiontName" multiple
                  item-value="_id" outlined dense label="Choose Division">
                </v-autocomplete>
              </v-flex>

              <v-flex xs12 sm6 align-self-center text-left pa-2 px-4>
                <v-autocomplete v-model="test" :items="positionList" item-text="name" item-value="_id" outlined dense
                  label="Choose Position(s)">
                </v-autocomplete>
              </v-flex>

              <v-flex xs12 sm6 align-self-center text-left pa-2 px-4>
                <v-text-field v-model="editingitem.roleName" outlined dense clearable label="Role">
                </v-text-field>
              </v-flex>
              <v-flex xs12 sm6 align-self-center text-left pa-2 px-4>
                <v-menu ref="menu4" v-model="menu4" :close-on-content-click="false" transition="scale-transition"
                  offset-y max-width="290px" min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="displayExitDate" label="Exit Date" outlined dense v-bind="attrs"
                      v-on="on"></v-text-field>
                  </template>
                  <v-date-picker v-model="editingitem.exitDate" no-title @input="menu4 = false"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12 sm6 align-self-center text-left pa-2 px-4>
                <v-select v-model="editingitem.exitType" :items="reasonsList" outlined dense label="Exit Type">
                </v-select>
              </v-flex>
              <v-flex xs12 sm6 align-self-center text-left pa-2 px-4>
                <v-textarea v-model="editingitem.exitReason" label="Exit Reason" :rules="[rules.required]" required
                  outlined dense></v-textarea>
              </v-flex>
              <v-flex xs12 sm6 align-self-center text-left pa-2 px-4>
                <v-textarea v-model="editingitem.eligibilitytoRehire" label="Eligibility to rehire"
                  :rules="[rules.required]" required outlined dense></v-textarea>
              </v-flex>
              <v-flex xs12 sm6 align-self-center text-left pa-2 px-4>
                <v-textarea v-model="editingitem.promotion" label="Promotions" :rules="[rules.required]" required
                  outlined dense></v-textarea>
              </v-flex>
              <v-flex xs12 sm6 align-self-center text-left pa-2 px-4>
                <v-textarea v-model="editingitem.others" label="Others" :rules="[rules.required]" required outlined
                  dense></v-textarea>
              </v-flex>
              <v-flex xs12 pa-4 pb-12 align-self-center>
                <v-divider></v-divider>
              </v-flex>

              <v-flex xs12 sm6 align-self-center text-left pa-2 px-4>
                <!-- <v-select
                  v-model="editingitem.administrativeReportingManager"
                  :items="empList"
                  item-text="name"
                  item-value="_id"
                  outlined
                  dense
                  label="Choose Administrative Reporting Manager"
                >
                </v-select> -->

                <v-autocomplete v-model="editingitem.administrativeReportingManagersIds" :items="empList1"
                  item-text="name" :search-input.sync="search1" item-value="_id" outlined multiple hide-details
                  label="Choose Administrative Reporting Manager" dense></v-autocomplete>
              </v-flex>

              <v-flex xs12 sm6 align-self-center text-left pa-2 px-4>
                <!-- <v-select
                  v-model="editingitem.technicalReportingManager"
                  :items="empList2"
                  item-text="name"
                  item-value="_id"
                  outlined
                  dense
                  label="Choose Technical Reporting Manager"
                >
                </v-select> -->
                <v-autocomplete v-model="editingitem.technicalReportingManagersIds" :items="empList2" item-text="name"
                  :search-input.sync="search2" item-value="_id" outlined multiple hide-details
                  label="Choose Technical Reporting Manager" dense></v-autocomplete>
              </v-flex>

              <v-flex xs12 sm6 align-self-center text-left pa-2 px-4>
                <!-- <v-select
                  v-model="editingitem.principalInvigilator"
                  :items="empList3"
                  item-text="name"
                  item-value="_id"
                  outlined
                  dense
                  label="Choose Principal Invigilator/Investigator"
                >
                </v-select> -->

                <v-autocomplete v-model="editingitem.principalInvigilator" :items="empList3" item-text="name"
                  :search-input.sync="search3" item-value="_id" outlined hide-details
                  label="Choose Principal Invigilator/Investigator" dense></v-autocomplete>
              </v-flex>
              <!-- <v-flex xs12 sm6 align-self-center text-left pa-2 px-4>
                <v-text-field v-model="editingitem.casualLeaves" label="Casual Leaves" type="number" outlined
                  dense></v-text-field>
              </v-flex> -->
              <v-flex xs12 sm6 align-self-center text-left pa-2 px-4>
                <v-select v-model="editingitem.fieldOfEducationCategory"
                  :items="['Highest Education', 'Additional Qualification']" label="Field of Education Category"
                  outlined dense :rules="[rules.required]" required
                  @change="editingitem.fieldOfEducation = null"></v-select>
              </v-flex>
              <v-flex xs12 sm6 align-self-center text-left pa-2 px-4
                v-if="editingitem.fieldOfEducationCategory === 'Highest Education'">
                <v-select v-model="editingitem.fieldOfEducation" :items="highestEducationOptions"
                  label="Highest Education" item-text="text" item-value="value" outlined dense :rules="[rules.required]"
                  required></v-select>
              </v-flex>
              <v-flex xs12 sm6 align-self-center text-left pa-2 px-4
                v-if="editingitem.fieldOfEducationCategory === 'Additional Qualification'">
                <v-select v-model="editingitem.fieldOfEducation" :items="additionalQualificationOptions"
                  label="Additional Qualification" item-text="text" item-value="value" outlined dense
                  :rules="[rules.required]" required></v-select>
              </v-flex>
              <v-flex xs12 sm6 align-self-center text-left pa-2 px-4>
                <v-select v-model="editingitem.staffType" :items="['HQ', 'Field']" label="Staff Type" outlined dense
                  :rules="[rules.required]" required></v-select>
              </v-flex>
              <v-flex xs12 sm6 align-self-center text-left pa-2 px-4>
                <v-text-field v-model="editingitem.experienceBeforeWTI" label="Experience before WTI"
                  :rules="[rules.required]" required outlined dense type="number"></v-text-field>
              </v-flex>
              <v-flex xs12 pa-4 align-self-center>
                <v-divider></v-divider>
              </v-flex>

              <v-flex xs12 sm6 pa-2 px-4 text-left v-if="flagg">
                <ImageComp @stepper="winStepper" :singleImage="editingitem.photo" :pageId="editingitem._id"
                  :height="'320'" :width="'320'" :heading="'Upload Profile Pic'" :componentType="'coverImage'" />
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" text @click="getdData"> Close </v-btn>
          <v-btn v-if="!g" color="blue darken-1" text @click="validateEdit()">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-layout wrap justify-center v-if="pages > 1">
      <v-flex align-self-center>
        <div class="pt-2">
          <v-pagination prev-icon="mdi-menu-left" next-icon="mdi-menu-right" :length="pages" :total-visible="7"
            v-model="currentPage" color="#005f32"></v-pagination>
        </div>
      </v-flex>
    </v-layout>
    <!-- Second Confirmation Dialog -->
    <v-dialog persistent v-model="showSecondDialog" max-width="600px">
      <v-card>
        <!-- <v-layout wrap>
    <v-flex
      xs12
      align-self-center
      pa-4
      style="background: #005f32"
      text-left
    >
      <span class="kumbhBold" style="color: #ffffff">Final Confirmation</span>
    </v-flex>
    
  </v-layout> -->
        <v-layout wrap pa-4 style="background: #005f32">
          <v-flex xs6 align-self-center text-left>
            <span class="kumbhBold" style="color: #ffffff; font-size: 20px">
              Delete Confirmation</span>
          </v-flex>
          <v-flex xs6 align-self-center text-right>
            <v-btn icon color="white" text @click="showSecondDialog = false">
              <v-icon color="#ffffff">mdi-close</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
        <v-card-title>
          Is this employee resigning?
        </v-card-title>
        <v-card-text>
          <v-checkbox v-model="isResigning" label="Yes, this employee is resigning." color="#005f32"></v-checkbox>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" tile dark @click="deleteItem(selectedItem)">
            NO
          </v-btn>
          <v-btn color="#005f32" outlined tile @click="deleteItem(selectedItem)">
            YES
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog persistent v-model="showReasonDialog" max-width="600px">
      <v-card>
        <v-layout wrap pa-4 style="background: #005f32">
          <v-flex xs6 align-self-center text-left>
            <span class="kumbhBold" style="color: #ffffff; font-size: 20px">
              Delete Confirmation
            </span>
          </v-flex>
          <v-flex xs6 align-self-center text-right>
            <v-btn icon color="white" text @click="showReasonDialog = false">
              <v-icon color="#ffffff">mdi-close</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
        <v-card-title>
          Please select the reason for deletion:
        </v-card-title>
        <v-card-text>
          <v-checkbox v-model="selectedReason" label="Resigned" value="Resigned" color="#005f32"></v-checkbox>
          <v-checkbox v-model="selectedReason" label="Terminated" value="Terminated" color="#005f32"></v-checkbox>
          <v-checkbox v-model="selectedReason" label="Absconded" value="Absconded" color="#005f32"></v-checkbox>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" tile dark @click="showReasonDialog = false">
            Cancel
          </v-btn>
          <v-btn color="#005f32" outlined tile @click="handleReasonConfirm">
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog persistent v-model="showRemarksDialog" max-width="600px">
      <v-card>
        <v-layout wrap pa-4 style="background: #005f32">
          <v-flex xs6 align-self-center text-left>
            <span class="kumbhBold" style="color: #ffffff; font-size: 20px">
              Final Confirmation
            </span>
          </v-flex>
          <v-flex xs6 align-self-center text-right>
            <v-btn icon color="white" text @click="showRemarksDialog = false">
              <v-icon color="#ffffff">mdi-close</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
        <v-card-title>
          <v-layout wrap>
            <v-flex xs12>
              <v-layout wrap justify-center>
                <v-flex xs12>
                  <v-menu v-model="menuLastWorkingDate" :close-on-content-click="false" :nudge-right="40"
                    transition="scale-transition" offset-y min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="displayLastWorkingDate" label="Date of Last Working Day" readonly outlined
                        dense v-bind="attrs" v-on="on"></v-text-field>
                    </template>
                    <v-date-picker v-model="lastWorkingDate" @input="menuLastWorkingDate = false"
                      no-title></v-date-picker>
                  </v-menu>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-card-text>
          <v-textarea v-model="officialExitReason" label="Official Exit Reason" :rules="[v => !!v || 'Official Exit Reason is mandatory']" required
            outlined dense></v-textarea>
          <v-textarea v-model="unofficialExitReason" label="Unofficial Exit Reason" :rules="[v => !!v || 'Unofficial Exit Reason is mandatory']" required
            outlined dense></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" tile dark @click="showRemarksDialog = false">
            Cancel
          </v-btn>
          <v-btn color="#005f32" outlined tile @click="handleRemarksConfirm">
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="attachmentDialog" persistent max-width="500px">
      <v-card>
        <v-form ref="attachmentForm">
          <v-card-title>
            <span class="headline">Add Employee Document</span>
          </v-card-title>
          <v-card-text>
            <v-layout wrap>
              <v-flex xs12 align-self-center text-left pt-5>
                <v-text-field v-model="attachmentFormData.docTitle" label="Document Name" :rules="[rules.required]"
                  required outlined dense></v-text-field>
              </v-flex>
              <v-flex xs12 pt-6>
                <v-icon x-large color="#408BFF" @click="$refs.attachmentFileInput.click()">mdi-cloud-upload</v-icon>
              </v-flex>
              <v-flex xs12 pb-5>
                <span class="con4">Upload Document</span>
                &nbsp;
                <input v-show="false" ref="attachmentFileInput" type="file" @change="onAttachmentFileChange" />
              </v-flex>
              <v-flex xs12 py-3 text-left>
                <v-chip v-if="attachmentFormData.documentUrl" close dark color="green"
                  @click:close="removeAttachmentFile" style="margin-right: 6px;">
                  {{ attachmentFormData.documentUrl.name }}
                </v-chip>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closeAttachmentDialog">
              Close
            </v-btn>
            <v-btn color="blue darken-1" text @click="uploadAttachment">
              Save
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <!-- Column Selection Dialog -->
    <v-dialog v-model="exportDialog" persistent max-width="600px">
      <v-card>
        <v-card-title class="kumbhBold" style="background: #005f32; color: white">
          Select Columns for Export
        </v-card-title>
        <v-card-text class="pa-4">
          <v-layout wrap>
            <v-flex xs12 mb-2>
              <v-btn small text @click="selectAllColumns" color="#005f32">Select All</v-btn>
              <v-btn small text @click="deselectAllColumns" color="error">Deselect All</v-btn>
            </v-flex>
            <v-flex xs12 sm6 v-for="(col, index) in availableColumns" :key="index">
              <v-checkbox
                v-model="selectedColumns"
                :label="col.text"
                :value="col.value"
                hide-details
                color="#005f32"
                dense
              ></v-checkbox>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="exportDialog = false">Cancel</v-btn>
          <v-btn color="#005f32" dark class="rounded-lg" @click="employeeListDownload" :disabled="selectedColumns.length === 0">
            Download Excel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import ImageComp from "./singleImage";
import axios from "axios";
import moment from "moment";
export default {
  props: ["employeeData", "dialogValue"],
  data() {
    return {
      numberRules: [
        (v) => !!v || "Allotted Leaves is required",
        (v) => /^[0-9]+$/.test(v) || "Allotted Leaves must be a valid number",
        (v) => (v && v >= 0) || "Allotted Leaves cannot be negative",
      ],
      //searchproject:"",
      test: null,
      showsnackbar: false,
      ServerError: false,
      msg: null,
      pages: 0,
      dialog: false,
      editdialog: false,
      viewMode: 'list',
      editingitem: [],
      name: "",
      pageCount: 1,
      appLoading: false,
      editedIndex: -1,
      currentPage: 1,
      g: false,
      perPage: 4,
      totalData: 0,
      totalRows: 0,
      dialogDelete: false,
      search: "",
      itemname: "",
      addcat: false,
      doc: "",
      sortList: [
        "Alphabetical Order",
        "Latest",
        "Oldest",
      ],
      ffsort: "",
      locationList: [
        "Baghmara, Garo Hills",
        "Bandhavgarh Tiger Reserve",
        "Bansbari,Assam",
        "Bijni, Assam",
        "CWRC, Assam",
        "Dimapur, Nagaland",
        "Done Valley, Bihar",
        "Gaunaha, Bihar",
        "Goa",
        "Gondia, Maharashtra",
        "Guijan, Assam",
        "Gurguria, West Bengal",
        "Hirpora, J&K",
        "HQ-Noida",
        "Kannur, Kerala",
        "Katarniaghat, UP",
        "Kazinag, J&K",
        "Keonjhar, Odisha",
        "Kokrajhar, Assam",
        "Mithapur, Gujarat",
        "Munnar, Kerala",
        "Namsing, Arunachal Pradesh",
        "Nichlaul, Maharajganj, UP",
        "Pakke, Arunachal Pradesh",
        "Pilibhit, UP",
        "Raimona National Park, Assam",
        "Shergaon, Arunachal Pradesh",
        "Similipal, Odisha",
        "Thrissur, Kerala",
        "Tura, Garo Hills",
        "Ujjain, MP",
        "Valmiki Nagar, Bihar",
        "Vazhanchal, Kerala",
        "Veraval, Gujarat",
        "Wayanad, Kerala",
      ],
      statusList: [
        {
          name: "On Probation",
        },
        {
          name: "Confirmed",
        },
      ],
      reasonsList: ["Primary", "Secondary", "Local resignation/termination"],
      rules: {
        required: (value) => !!value || "Required.",
      },
      employeeList: [],
      data: [],
      coverImageFile: null,
      selectedFiles: [],
      image: null,
      role: null,
      coverImageArray: [],
      formDataCover: new FormData(),
      flagg: true,
      highestEducationOptions: [
        { value: 'Bachelors', text: 'Bachelors' },
        { value: 'Masters', text: 'Masters' },
        { value: 'PhD', text: 'PhD' },
      ],
      additionalQualificationOptions: [
        { value: '1-year Diploma', text: '1-year Diploma' },
        { value: '2-year Diploma', text: '2-year Diploma' },
        // { value: 'Certificate Course', text: 'Certificate Course' },
      ],
extensionOptions: [
  { text: "1M", value: 1 },
  { text: "2M", value: 2 },
  { text: "3M", value: 3 },
  { text: "4M", value: 4 },
  { text: "5M", value: 5 },
  { text: "6M", value: 6 },
],      user: {
        dob: new Date(),
        dateofjoining: new Date(),
        dateofProbationCompletion: new Date(),
        exitDate: new Date(),
        experienceBeforeWTI: null,
        fieldOfEducationCategory: null,
        fieldOfEducation: null,
        staffType: null,
        probationExtensionMonths: null,
      },
      file: "",
      menu: false,
      menu1: false,
      menu2: false,
      menu22: false,
      menu3: false,
      menu4: false,
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],
      roleRules: [(v) => !!v || "Role is required"],
      phnoRules: [
        (v) => !!v || "Phone is required",
        (v) => /^\d{10}$/.test(v) || "Phone is invalid",
      ],
      departmentList: [],
      projectList: [],
      divisionList: [],
      positionList: null,
      project: null,
      department: null,
      division: [],
      empList1: [],
      empList2: [],
      empList3: null,
      search1: null,
      search2: null,
      officialExitReason: "",
      unofficialExitReason: "",
      deleteReason: "",
      attachmentDialog: false,
      attachmentFormData: {
        docTitle: '',
        documentUrl: null,
        employeeId: null,
      },
      search3: null,
      search11: null,
      search22: null,
      searchInput: null,
      search33: null,
      keysearch: null,
      timeout: null,
      ffprojectList: null,
      ffproject: null,
      ffdepartmentList: null,
      ffdepartment: null,
      ffpositionList: null,
      ffposition: null,
      ffreportingManager: null,
      ffadministrativereportingManager: null,
      fflocation: null,
      searchManager: null,
      searchAdminstrativeManager: null,
      ffsalaryMin: null,
      ffsalaryMax: null,
      moreFilter: false,
      maxDate: this.calculateMaxDate(),

      showSecondDialog: false,
      selectedItem: null,
      isResigning: false,
      showReasonDialog: false, // NEW: for first dialog
      showRemarksDialog: false, // NEW: for remarks dialog
      selectedReason: '', // NEW: 'Resigned', 'Terminated', 'Absconded'
      menuLastWorkingDate: false,
      lastWorkingDate: '',
    probationDurations: ["6 Months", "12 Months"],
    exportDialog: false,
    selectedColumns: [],
    availableColumns: [
      { text: 'Employee ID', value: 'employeeId' },
      { text: 'Name', value: 'name' },
      { text: 'Gender', value: 'gender' },
      { text: 'Email', value: 'email' },
      { text: 'Phone No', value: 'phonenumber' },
      { text: 'Location', value: 'location' },
      { text: 'DOJ', value: 'dateofjoining' },
      { text: 'Grade', value: 'grade' },
      { text: 'Designation Name', value: 'positionid' },
      { text: 'Administratively Reporting Emp Name', value: 'administrativeReportingManager' },
      { text: 'Probation Status', value: 'employeeStatus' },
      { text: 'Department', value: 'department' },
      { text: 'Division Name', value: 'division' },
      { text: 'Projects', value: 'projects' },
      { text: 'Role', value: 'roleName' },
      { text: 'Technically Reporting Emp Name', value: 'technicalReportingManager' },
      { text: 'DOB', value: 'dob' },
      { text: 'Age', value: 'age' },
      { text: 'Blood Group', value: 'bloodGroup' },
      { text: 'Marital Status', value: 'maritalStatus' },
      { text: 'Fathers Name', value: 'fathersName' },
      { text: 'Mothers Name', value: 'mothersName' },
      { text: 'Place of Birth', value: 'placeOfBirth' },
      { text: 'Nationality', value: 'nationality' },
      { text: 'Date of Marriage', value: 'dateOfMarriage' },
      { text: 'Spouse Name', value: 'spouseName' },
      { text: 'Spouse Occupation', value: 'spouseOccupation' },
      { text: 'Spouse Organization', value: 'spouseOrganization' },
      { text: 'Mother Tongue', value: 'motherTongue' },
      { text: 'Hobbies', value: 'hobbies' },
      { text: 'Social Work', value: 'socialWork' },
      { text: 'Sports Participation', value: 'sportsParticipation' },
      { text: 'Special Interests', value: 'specialInterests' },
      { text: 'PAN Card Num', value: 'panCardNum' },
      { text: 'Aadhaar Card Num', value: 'adharCardNum' },
      { text: 'Passport Number', value: 'passportNumber' },
      { text: 'Driving License', value: 'drivingLicense' },
      { text: 'Bank Name', value: 'bankName' },
      { text: 'Account Num', value: 'acNum' },
      { text: 'IFSC', value: 'ifsc' },
      { text: 'EPF UAN', value: 'epfUan' },
      { text: 'Emergency Contact Name', value: 'emergencyContactName' },
      { text: 'Emergency Contact No', value: 'emergencyContactNo' },
      { text: 'Emergency Contact Address', value: 'emergencyContactAddress' },
      { text: 'Mailing Address', value: 'mailingAddress' },
      { text: 'Mailing PIN', value: 'mailingPin' },
      { text: 'Permanent Address', value: 'permanentAddress' },
      { text: 'Permanent PIN', value: 'permanentPin' },
    ],
  };
},
  components: {
    ImageComp,
  },
  watch: {
    // searchproject(val) {
    //   this.loading = true;
    //   setTimeout(() => {
    //     this.getffProject(val);
    //     this.loading = false;
    //   }, 500);
    // },
    'user.monthlyCTC'(newVal) {
      if (newVal && !isNaN(newVal)) {
        this.user.yearlyPackage = parseFloat(newVal) * 12;
      } else {
        this.user.yearlyPackage = null;
      }
    },
    'editingitem.monthlyCTC'(newVal) {
      if (newVal && !isNaN(newVal)) {
        this.editingitem.yearlyPackage = parseFloat(newVal) * 12;
      } else {
        this.editingitem.yearlyPackage = null;
      }
    },
    department() {
      this.user.positionid = null;
      this.getPositions();
    },
    project() {
      this.user.positionid = null;
      // this.getPositions();
    },
    search1() {
      this.search = this.search1;
      this.getUsers1();
    },
    search2() {
      this.search = this.search2;
      this.getUsers2();
    },
    search3() {
      this.search = this.search3;
      this.getUsers3();
    },
    search11() {
      this.search = this.search11;
      this.getUsers1();
    },
    search22() {
      this.search = this.search22;
      this.getUsers2();
    },
    search33() {
      this.search = this.search33;
      this.getUsers3();
    },
    keysearch() {
      this.updateQuery();
      if (this.timeout) clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        if (!this._restoring && this.currentPage > 1) this.currentPage = 1;
        this.getData();
      }, 500);
    },
    currentPage() {
      this.getData();
      this.updateQuery();
    },
    ffdepartment() {
      if (!this._restoring) this.currentPage = 1;
      this.getffProject();
      this.getFilterPositions();
      this.updateQuery();
    },
    ffsort() {
      if (!this._restoring) this.currentPage = 1;
      this.getData();
      this.updateQuery();
    },
    ffproject() {
      if (!this._restoring) this.currentPage = 1;
      this.getFilterPositions();
      this.updateQuery();
    },
    ffposition() {
      if (!this._restoring) this.currentPage = 1;
      this.getData();
      this.updateQuery();
    },
    ffreportingManager() {
      if (!this._restoring) this.currentPage = 1;
      this.getData();
      this.updateQuery();
    },
    ffadministrativereportingManager() {
      if (!this._restoring) this.currentPage = 1;
      this.getData();
      this.updateQuery();
    },
    fflocation() {
      if (!this._restoring) this.currentPage = 1;
      this.getData();
      this.updateQuery();
    },
    ffsalaryMin() {
      if (!this._restoring) this.currentPage = 1;
      this.getData();
      this.updateQuery();
    },
    ffsalaryMax() {
      if (!this._restoring) this.currentPage = 1;
      this.getData();
      this.updateQuery();
    },
    searchManager() {
      this.search = this.searchManager;
      this.getUsers1();
    },
    searchAdminstrativeManager() {
      this.search = this.search22;
      this.getUsers2();
    },
    'user.dateofjoining'(newVal) {
      if (newVal) {
        this.calculateProbationDate(this.user);
      }
    },
    'editingitem.dateofjoining'(newVal) {
      if (newVal) {
        this.calculateProbationDate(this.editingitem);
      }
    },
  },
  created() {
    this._restoring = true;
    if (this.$route && this.$route.query) {
      const q = this.$route.query;
      if (q.page) {
        const p = parseInt(q.page, 10);
        if (p > 0) this.currentPage = p;
      }
      if (q.search) this.keysearch = q.search;
      if (q.department) this.ffdepartment = q.department;
      if (q.project) this.ffproject = q.project;
      if (q.position) this.ffposition = q.position;
      if (q.reportingManager) this.ffreportingManager = q.reportingManager;
      if (q.admReportingManager) this.ffadministrativereportingManager = q.admReportingManager;
      if (q.location) this.fflocation = q.location;
      if (q.salaryMin) this.ffsalaryMin = q.salaryMin;
      if (q.salaryMax) this.ffsalaryMax = q.salaryMax;
      if (q.sort) this.ffsort = q.sort;
      if (q.moreFilter === "1") this.moreFilter = true;
      if (q.position && !q.department && !q.project) this.getFilterPositions();
    }
    this.$nextTick(() => {
      this._restoring = false;
    });
  },
  beforeMount() {
    this.getffDept();
    this.getDept();
    this.getProject();
    this.getDivisions();
    this.getUsers1(); //for filtering purpose
    this.getUsers2(); //for filtering purpose
    this.getPositions();
  },
  computed: {
    displayDob() {
      return this.formatDateForDisplay(this.user.dob);
    },
    displayDateOfJoining() {
      return this.formatDateForDisplay(this.user.dateofjoining);
    },
    displayEditDob() {
      return this.formatDateForDisplay(this.editingitem.dob);
    },
    displayEditDateOfJoining() {
      return this.formatDateForDisplay(this.editingitem.dateofjoining);
    },
    displayExitDate() {
      return this.formatDateForDisplay(this.editingitem.exitDate);
    },
    displayLastWorkingDate() {
      return this.formatDateForDisplay(this.lastWorkingDate);
    },
  },
  mounted() {
    // this.getUsers("");
    if (this.user.dob) {
      this.user.dob = null;
      this.user.dateofjoining = null;
      this.user.dateofProbationCompletion = null;
      // this.user.dob.setDate(this.user.dob.getDate());
      // this.user.dob = this.user.dob.toISOString().substr(0, 10);
    }

    this.getData();
    if (this.$route.query.dialogValue == "true") {
      this.editdialog = true;
      //  this.editingitem._id = this.$route.query.id;

      this.editingitem._id = this.$route.query.employeeData._id;
      this.editingitem.name = this.$route.query.employeeData.name;
      this.editingitem.email = this.$route.query.employeeData.email;
      this.editingitem.phonenumber = this.$route.query.employeeData.phonenumber;
      // this.editingitem.employeeId = this.$route.query.employeeData.employeeId;
      this.editingitem.employeeStatus =
        this.$route.query.employeeData.employeeStatus;
    }
  },
  beforeDestroy() {
    if (this.timeout) clearTimeout(this.timeout);
    if (this._queryTimeout) clearTimeout(this._queryTimeout);
  },
  methods: {
    getProjectNames(projects) {
      if (!projects || !Array.isArray(projects) || projects.length === 0) return '';
      for (let p of projects) {
        let projId = p._id || p;
        let projObj = this.projectList.find(proj => proj._id === projId);
        if (projObj && projObj.projectName) return projObj.projectName;
        if (p.projectName) return p.projectName;
        if (p.name) return p.name;
      }
      return '';
    },
    formatDateForDisplay(date) {
      if (!date) return null;
      const [year, month, day] = date.split('-');
      return `${day}-${month}-${year}`;
    },

    formatDateForPicker(date) {
      if (!date) return null;
      const [day, month, year] = date.split('-');
      return `${year}-${month}-${day}`;
    },
    calculateProbationDate(item) {
      if (!item) return;
      const joiningDate = item.dateofjoining || item.dateofJoining;
      if (!joiningDate || !item.probationDuration) return;

      const baseMonths = parseInt(item.probationDuration, 10);
      if (isNaN(baseMonths)) return;

      const extension = parseInt(item.probationExtensionMonths, 10) || 0;
      const totalMonths = baseMonths + extension;

      const joinDate = moment(joiningDate);
      if (joinDate.isValid()) {
        item.dateofProbationCompletion = joinDate.add(totalMonths, "months").format("YYYY-MM-DD");
      }
    },
    openAttachmentDialog(item) {
      this.attachmentFormData = {
        docTitle: '',
        documentUrl: null,
        employeeId: item._id, // or item.employeeId if that's your backend id
      };
      this.attachmentDialog = true;
    },
    closeAttachmentDialog() {
      this.attachmentDialog = false;
      this.attachmentFormData = { docTitle: '', documentUrl: null, employeeId: null };
    },
    onAttachmentFileChange(e) {
      const file = e.target.files[0];
      if (file) {
        this.attachmentFormData.documentUrl = file;
      }
    },
    removeAttachmentFile() {
      this.attachmentFormData.documentUrl = null;
    },
    async uploadAttachment() {
      if (!this.attachmentFormData.docTitle || !this.attachmentFormData.documentUrl) {
        this.msg = "Please provide both document name and file";
        this.showsnackbar = true;
        return;
      }
      const formData = new FormData();
      formData.append('docTitle', this.attachmentFormData.docTitle);
      formData.append('documentUrl', this.attachmentFormData.documentUrl);

      this.appLoading = true;
      try {
        const res = await axios({
          url: `/employeedocs/upload/${this.attachmentFormData.employeeId}`,
          method: 'POST',
          headers: {
            "x-auth-token": localStorage.getItem("token"),
            "Content-Type": "multipart/form-data"
          },
          data: formData
        });
        this.appLoading = false;
        this.attachmentDialog = false;
        this.msg = res.data.msg || "Document uploaded successfully";
        this.showsnackbar = true;
        // Optionally refresh employee list or documents here
      } catch (err) {
        this.appLoading = false;
        this.msg = (err.response && err.response.data && err.response.data.msg) || "Failed to upload document";
        this.showsnackbar = true;
      }
    },
    calculateMaxDate() {
      // Create a new Date object for the current date
      const now = new Date();
      // Subtract 17 years from the current year
      const year = now.getFullYear() - 18;
      // Set the maxDate to December 31st of the calculated year
      const maxDate = new Date(year, 11, 31); // 11 represents December
      // Format the date in YYYY-MM-DD format (Vuetify expects this format)
      return maxDate.toISOString().split("T")[0];
    },
    addExp(data, index) {
      this.experienceArray[index].experience.push(data);
    },
    openExportDialog() {
      this.selectedColumns = this.availableColumns.map(col => col.value);
      this.exportDialog = true;
    },
    selectAllColumns() {
      this.selectedColumns = this.availableColumns.map(col => col.value);
    },
    deselectAllColumns() {
      this.selectedColumns = [];
    },
    employeeListDownload() {
      this.exportDialog = false;
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/employees/getalllist/excel",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          keyword: this.keysearch,
          positionid: this.ffposition,
          reportingManagerId: this.ffreportingManager,
          admReportingManagerId: this.ffadministrativereportingManager,
          location: this.fflocation,
          salaryMin: this.ffsalaryMin,
          salaryMax: this.ffsalaryMax,
          columns: this.selectedColumns,
        },
        responseType: "blob", // Specify the response type as blob
      })
        .then((response) => {
          this.appLoading = false;
          // Ensure the correct MIME type for Excel files
          const contentType =
            response.headers["content-type"] ||
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
          const blob = new Blob([response.data], { type: contentType });
          const url = window.URL.createObjectURL(blob);

          // Create a temporary anchor element
          const anchor = document.createElement("a");
          anchor.href = url;
          anchor.target = "_blank"; // Open in a new tab
          anchor.download = "Employee_List.xlsx"; // Set the file name

          // Programmatically click on the anchor to download the file
          anchor.click();

          // Clean up
          window.URL.revokeObjectURL(url);
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getFilterPositions() {
      this.appLoading = true;
      axios({
        url: "/getalllist/position/v1",
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          projectid: this.project,
          isDetailed: true,
          departmentIds: this.ffdepartment,
          positionid: this.positionid,
          projectIds: this.ffproject,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.ffpositionList = response.data.data;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

    getffDept() {
      this.appLoading = true;
      axios({
        url: "/department/getalllist",
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.ffdepartmentList = response.data.data;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getffProject() {
      this.appLoading = true;
      axios({
        url: "/projects/getalllist",
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          departmentId: this.ffdepartment,
          // keyword: val,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.ffprojectList = response.data.data;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    winStepper(window_data) {
      if (window_data.type == "coverImage") {
        this.coverImageFile = window_data.selectedFiles;
      }
    },
    getAge(dateString) {
      var today = new Date();
      var birthDate = new Date(dateString);
      var age = today.getFullYear() - birthDate.getFullYear();
      var m = today.getMonth() - birthDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      // return age;
      this.user.age = age;
      this.editingitem.age = age;
    },

    getUsers1() {
      this.appLoading = true;
      axios({
        url: "/employees/getalllist/search",
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          except: this.editingitem._id,
          keyword: this.search,

        },
      })
        .then((response) => {
          this.appLoading = false;
          this.empList1 = response.data.data;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getUsers2() {
      this.appLoading = true;
      axios({
        url: "/employees/getalllist/search",
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          except: this.editingitem._id,
          keyword: this.search,

        },
      })
        .then((response) => {
          this.appLoading = false;
          this.empList2 = response.data.data;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getUsers3() {
      this.appLoading = true;
      axios({
        url: "/employees/getalllist/search",
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          except: this.editingitem._id,
          keyword: this.search,

        },
      })
        .then((response) => {
          this.appLoading = false;
          this.empList3 = response.data.data;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getDept() {
      this.appLoading = true;
      axios({
        url: "/department/getalllist",
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.departmentList = response.data.data;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getProject() {
      this.appLoading = true;
      axios({
        url: "/projects/getalllist",
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.projectList = response.data.data;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

    getDivisions() {
      this.appLoading = true;
      axios({
        url: "/division/list",
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.divisionList = response.data.data;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

    getPositions() {
      this.appLoading = true;
      axios({
        url: "/getalllist/position/v1",
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          isDetailed: true,
          departmentIds: this.department,
          projectIds: this.project,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.positionList = response.data.data;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getdData() {
      this.editdialog = false;
      this.getData();
    },

    // openSecondDialog(item) {
    //   this.selectedItem = item;
    //   this.showSecondDialog = true;
    //   item.delete = false; // Close the first dialog when opening the second
    //   this.deleteReason = item.deleteReason;
    // },
    openSecondDialog(item) {
      this.selectedItem = item;
      this.selectedReason = '';
      this.showReasonDialog = true;
      item.delete = false; // Close the first dialog when opening the second
      this.deleteReason = '';
      this.officialExitReason = '';
      this.unofficialExitReason = '';
    },
    handleReasonConfirm() {
      if (!this.selectedReason) {
        this.msg = "Please select a reason";
        this.showsnackbar = true;
        return;
      }
      this.showReasonDialog = false;
      this.showRemarksDialog = true;
    },
    handleRemarksConfirm() {
      // Validation for dates
      if (!this.lastWorkingDate) {
        this.msg = "Please select Date of Last Working Day";
        this.showsnackbar = true;
        return;
      }
      if (!this.officialExitReason) {
        this.msg = "Official Exit Reason is mandatory";
        this.showsnackbar = true;
        return;
      }
      if (!this.unofficialExitReason) {
        this.msg = "Unofficial Exit Reason is mandatory";
        this.showsnackbar = true;
        return;
      }
      this.deleteItem(this.selectedItem);
    },
    // deleteItem(cat) {
    //   if (!cat) return;

    //   const data = {
    //     employeeId: cat._id,
    //     isResign: this.isResigning,
    //     remarks: this.deleteReason || cat.deleteReason,
    //   };

    //   axios({
    //     url: "/delete/employee",
    //     method: "POST",
    //     headers: {
    //       "x-auth-token": localStorage.getItem("token"),
    //     },
    //     data: data,
    //   })
    //     .then((response) => {
    //       this.showSecondDialog = false;  // Close the second dialog
    //       this.appLoading = false;
    //       this.msg = response.data.msg;
    //       this.showsnackbar = true;
    //       this.getData();
    //     })
    //     .catch((err) => {
    //       this.appLoading = false;
    //       this.ServerError = true;
    //       console.log(err);
    //     });
    // },
    deleteItem(cat) {
      if (!cat) return;

      // Set flags based on selectedReason
      const data = {
        employeeId: cat._id,
        remarks: `Official: ${this.officialExitReason} | Unofficial: ${this.unofficialExitReason}`,
        officialExitReason: this.officialExitReason,
        unofficialExitReason: this.unofficialExitReason,
        isResign: this.selectedReason === 'Resigned',
        isTerminated: this.selectedReason === 'Terminated',
        isAbsconded: this.selectedReason === 'Absconded',
        resignationDate: this.selectedReason === 'Resigned' ? this.lastWorkingDate : undefined,
        lastWorkingDay: this.lastWorkingDate || undefined,
      };

      axios({
        url: "/delete/employee",
        method: "POST",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: data,
      })
        .then((response) => {
          this.showRemarksDialog = false;
          this.appLoading = false;
          this.msg = response.data.msg;
          this.showsnackbar = true;
          this.getData();
          this.lastWorkingDate = '';
          this.deleteReason = '';
          this.officialExitReason = '';
          this.unofficialExitReason = '';
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getData() {
      // this.appLoading = true;
      axios({
        url: "/employees/getalllist",
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          keyword: this.keysearch,
          page: this.currentPage,
          limit: 20,
          positionid: this.ffposition,
          reportingManagerId: this.ffreportingManager,
          admReportingManagerId: this.ffadministrativereportingManager,
          location: this.fflocation,
          salaryMin: this.ffsalaryMin,
          salaryMax: this.ffsalaryMax,
          sort: this.ffsort,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.employeeList = response.data.data;

          this.totalData = response.data.length;
          this.pages = Math.ceil(this.totalData / response.data.limit);
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    updateQuery() {
      // The layout's <router-view :key="$route.fullPath"> remounts the whole
      // page whenever the query string changes, so this must be debounced -
      // otherwise every keystroke in a filter field (e.g. min/max salary)
      // remounts the page and the input loses focus mid-type.
      if (this._queryTimeout) clearTimeout(this._queryTimeout);
      this._queryTimeout = setTimeout(() => {
        const query = {};
        if (this.currentPage > 1) query.page = String(this.currentPage);
        if (this.keysearch) query.search = this.keysearch;
        if (this.ffdepartment) query.department = this.ffdepartment;
        if (this.ffproject) query.project = this.ffproject;
        if (this.ffposition) query.position = this.ffposition;
        if (this.ffreportingManager) query.reportingManager = this.ffreportingManager;
        if (this.ffadministrativereportingManager) query.admReportingManager = this.ffadministrativereportingManager;
        if (this.fflocation) query.location = this.fflocation;
        if (this.ffsalaryMin) query.salaryMin = this.ffsalaryMin;
        if (this.ffsalaryMax) query.salaryMax = this.ffsalaryMax;
        if (this.ffsort) query.sort = this.ffsort;
        if (this.moreFilter) query.moreFilter = "1";
        this.$router.replace({ query }).catch(() => {});
      }, 600);
    },
    dialogclose() {
      this.name = null;
      this.project = null;
      this.department = null;
      this.division = [];
      this.user.administrativeReportingManager = null;
      this.dialog = false;
    },

    validateEmp() {
      const now = new Date();
      const year = now.getFullYear() - 18;
      const maxDate = new Date(year, 11, 31); // December 31st of the calculated year

      // Convert dob to a Date object
      const dobDate = new Date(this.user.dob);

      // Check if dobDate is a valid date
      if (isNaN(dobDate.getTime())) {
        this.msg = "Invalid Date of Birth format";
        this.showsnackbar = true;
        return;
      }
      if (!this.user.employeeId) {
        this.msg = "Please provide employee id";
        this.showsnackbar = true;
        return;
      } else if (!this.user.name) {
        this.msg = "Please provide employee name";
        this.showsnackbar = true;
        return;
      } else if (!this.user.email) {
        this.msg = "Please provide email";
        this.showsnackbar = true;
        return;
      } else if (!this.user.phonenumber) {
        this.msg = "Please provide employee phone no.";
        this.showsnackbar = true;
        return;
      }
      else if (dobDate > maxDate) {
        this.msg = "Please Provide valid Date of Birth";
        this.showsnackbar = true;
        return;
      }
      // else if (!this.user.address) {
      //   this.msg = "Please provide employee address";
      //   this.showsnackbar = true;
      //   return;
      // }
      else if (!this.user.gender) {
        this.msg = "Please provide gender";
        this.showsnackbar = true;
        return;
      }
      // else if (!this.department) {
      //   this.msg = "Please provide department";
      //   this.showsnackbar = true;
      //   return;
      // }
      else if (!this.user.positionid) {
        // if(!this.user.positionid.length>0) {
        this.msg = "Please provide position";
        this.showsnackbar = true;
        return;
        // }
      } else if (!this.user.experienceBeforeWTI) {
        this.msg = "Please provide Experience before WTI";
        this.showsnackbar = true;
        return;
      } else if (!this.user.fieldOfEducationCategory) {
        this.msg = "Please select Field of Education Category";
        this.showsnackbar = true;
        return;
      } else if (!this.user.fieldOfEducation) {
        this.msg = "Please select " + (this.user.fieldOfEducationCategory === 'Highest Education' ? 'Highest Education' : 'Additional Qualification');
        this.showsnackbar = true;
        return;
      } else if (!this.user.staffType) {
        this.msg = "Please select Staff Type";
        this.showsnackbar = true;
        return;
      }
      // else if (!/^[0-9]+$/.test(this.user.allotedLeaves)) {
      //   this.msg = "Allotted Leaves must be a valid number";
      //   this.showsnackbar = true;
      //   return;
      // } else if (this.user.allotedLeaves < 0) {
      //   this.msg = "Allotted Leaves cannot be negative";
      //   this.showsnackbar = true;
      //   return;
      // }
      else {
        this.addEmployee();
      }
    },

    addEmployee() {
      // this.user.departmentid = this.department;
      this.user.projectid = this.project;
      this.user.divisionId = this.division;

      axios({
        url: "/employee/add/v2",
        method: "POST",
        data: this.user,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.msg = "Added Sucessfully";
            this.showsnackbar = true;
            if (response.data.data._id && this.coverImageFile)
              this.uploadCoverImages(response.data.data._id);
            else this.getData();
            this.user = {};
            this.dialog = false;
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    uploadCoverImages(id) {
      this.flagg = false;
      this.appLoading = true;
      this.formDataCover.append("photo", this.coverImageFile);
      axios({
        method: "POST",
        url: "/employee/photo/upload/" + id,
        data: this.formDataCover,
        headers: {
          "Content-Type": "multipart/form-data",
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.formDataCover = new FormData();
            this.msg = response.data.msg;
          } else {
            this.msg = "Can't Upload Profile Image.. Please Try Again Later";
            this.showSnackBar = true;
            this.formDataCover = new FormData();
          }
          this.getData();
          this.flagg = true;
        })
        .catch((err) => {
          this.appLoading = false;
          this.msg = "Can't Upload Profile Image.. Please Try Again Later";
          this.showSnackBar = true;
          console.log(err);
        });
    },

    editcat(item) {
      // this.getUsers(item._id);
      this.getUsers1();
      this.getUsers2();
      this.getUsers3();
      this.getDivisions();
      this.department = null;
      this.project = null;
      var deptAr = [],
        projAr = [];
      this.editingitem = item;
      // Add this new code to set Field of Education and Experience
      // this.editingitem.experienceBeforeWTI = item.experienceBeforeWTI;
      // this.editingitem.fieldOfEducationCategory = item.fieldOfEducationCategory;
      // this.editingitem.fieldOfEducation = item.fieldOfEducation;
      this.$set(this.editingitem, 'experienceBeforeWTI', item.experienceBeforeWTI || null);
      this.$set(this.editingitem, 'fieldOfEducationCategory', item.fieldOfEducationCategory || null);
      this.$set(this.editingitem, 'fieldOfEducation', item.fieldOfEducation || null);
      let divAr = [];
      if (Array.isArray(item.divisionId)) {
        divAr = item.divisionId.map(d => typeof d === 'object' ? d._id : d);
      } else if (item.divisionId) {
        divAr = [typeof item.divisionId === 'object' ? item.divisionId._id : item.divisionId];
      } else if (item.division && Array.isArray(item.division)) {
        divAr = item.division.map(d => typeof d === 'object' ? d._id : d);
      } else if (item.division) {
        divAr = [typeof item.division === 'object' ? item.division._id : item.division];
      }
      this.$set(this.editingitem, 'division', divAr);
      this.$set(this.editingitem, 'staffType', item.staffType || null);
      this.$set(this.editingitem, 'probationExtensionMonths', item.probationExtensionMonths || null);
      if (item.probationDuration) {
        this.$set(this.editingitem, 'probationDuration', item.probationDuration);
      } else if (item.dateofjoining && item.dateofProbationCompletion) {
        const start = moment(item.dateofjoining);
        const end = moment(item.dateofProbationCompletion);
        const totalMonths = end.diff(start, 'months');
        const ext = parseInt(item.probationExtensionMonths, 10) || 0;
        const base = totalMonths - ext;
        if (base === 12) {
          this.$set(this.editingitem, 'probationDuration', '12 Months');
        } else {
          this.$set(this.editingitem, 'probationDuration', '6 Months');
        }
      }
      // Add this new code to fetch casual leaves
      if (item.leaveDetails && item.leaveDetails.length > 0) {
        const firstLeaveDetail = item.leaveDetails[0];
        if (firstLeaveDetail.leaveDetails && firstLeaveDetail.leaveDetails.length > 0) {
          const casualLeave = firstLeaveDetail.leaveDetails.find(leave => leave.leaveCategory === 'Casual');
          if (casualLeave) {
            this.editingitem.casualLeaves = casualLeave.totalLeaves;
          }
        }
      }
      if (this.editingitem.dob) {
        this.editingitem.dob = this.editingitem.dob.slice(0, 10);

        this.getAge(this.editingitem.dob);
      }
      if (this.editingitem.dateofjoining) {
        this.editingitem.dateofjoining = this.editingitem.dateofjoining.slice(
          0,
          10
        );
      }
      if (this.editingitem.dateofProbationCompletion) {
        this.editingitem.dateofProbationCompletion =
          this.editingitem.dateofProbationCompletion.slice(0, 10);
      }
      if (this.editingitem.exitDate) {
        this.editingitem.exitDate = this.editingitem.exitDate.slice(0, 10);
      }
      // for (let i = 0; i < this.editingitem.positionid.length; i++) {
      //   if (this.editingitem.positionid[i].type == "Department") {
      // deptAr = this.editingitem.positionid[i].department;
      //   deptAr.push(this.editingitem.positionid[i].department);
      // }
      // if (this.editingitem.positionid[i].type == "Project") {
      //   projAr.push(this.editingitem.positionid[i].project);
      // }
      // }
      this.department = deptAr;
      this.project = projAr;
      this.editdialog = true;
    },

    validateEdit() {
      var phoneformat = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
      var emailformat =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      var phonenumber = String(this.editingitem.phonenumber);
      const now = new Date();
      const year = now.getFullYear() - 18;
      const maxDate = new Date(year, 11, 31); // December 31st of the calculated year

      // Convert dob to a Date object
      const dobDate = new Date(this.editingitem.dob);

      // Check if dobDate is a valid date
      if (isNaN(dobDate.getTime())) {
        this.msg = "Invalid Date of Birth format";
        this.showsnackbar = true;
        return;
      }

      if (!this.editingitem.employeeId) {
        this.msg = "Please provide employee id";
        this.showsnackbar = true;
        return;
      } else if (!this.editingitem.name) {
        this.msg = "Please provide employee name";
        this.showsnackbar = true;
        return;
      } else if (!this.editingitem.email) {
        this.msg = "Please provide email";
        this.showsnackbar = true;
        return;
      } else if (
        this.editingitem.email &&
        !this.editingitem.email.match(emailformat)
      ) {
        this.msg = "Please Provide valid Email";
        this.showsnackbar = true;
        return;
      } else if (!phonenumber) {
        this.msg = "Please provide employee phone no.";
        this.showsnackbar = true;
        return;
      } else if (phonenumber && !phonenumber.match(phoneformat)) {
        this.msg = "Please Provide valid Phone Number";
        this.showsnackbar = true;
        return;
      } else if (dobDate > maxDate) {
        this.msg = "Please Provide valid Date of Birth";
        this.showsnackbar = true;
        return;
      }
      // else if (!this.editingitem.address) {
      //   this.msg = "Please provide employee address";
      //   this.showsnackbar = true;
      //   return;
      // }
      else if (!this.editingitem.gender) {
        this.msg = "Please provide gender";
        this.showsnackbar = true;
        return;
      }
      //  else if (!this.department) {
      //    this.msg = "Please provide department";
      //    this.showsnackbar = true;
      //    return;
      //  }
      else if (!this.editingitem.positionid) {
        this.msg = "Please provide position";
        this.showsnackbar = true;
        return;
      }
      //  else if (this.editingitem.casualLeaves === undefined || this.editingitem.casualLeaves < 0) {
      //   this.msg = "Please provide a valid number of casual leaves";
      //   this.showsnackbar = true;
      //   return;
      // } 
      else if (!this.editingitem.experienceBeforeWTI) {
        this.msg = "Please provide Experience before WTI";
        this.showsnackbar = true;
        return;
      } else if (!this.editingitem.fieldOfEducationCategory) {
        this.msg = "Please select Field of Education Category";
        this.showsnackbar = true;
        return;
      } else if (!this.editingitem.fieldOfEducation) {
        this.msg = "Please select " + (this.editingitem.fieldOfEducationCategory === 'Highest Education' ? 'Highest Education' : 'Additional Qualification');
        this.showsnackbar = true;
        return;
      }
      else {
        this.edit();
      }
    },
    edit() {
      // console.log("this.editingitem==",this.editingitem)
      this.editingitem.id = this.editingitem._id;
      // data["name"] = this.editingitem.name;
      this.editingitem.positionid = this.test;
      this.editingitem.departmentid = this.department;
      // this.editingitem.role = this.role;
      this.editingitem.projectid = this.editingitem.projects;
      const data = {
        ...this.editingitem,
        allottedLeaves: this.editingitem.casualLeaves,
        divisionId: this.editingitem.division
      };
      axios({
        url: "/employee/edit/v2",
        method: "POST",
        // data: this.editingitem,
        data: data,

        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.editdialog = false;
          this.appLoading = false;
          if (response.data.status) {
            if (this.coverImageFile) {
              this.uploadCoverImages(this.editingitem._id);
            }
            this.msg = "Edited Sucessfully";
            this.showsnackbar = true;
            this.getData();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
            this.getData();
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>